import { Outlet, Link, useNavigate } from "react-router-dom";
import { Sidebar, type SidebarNavItem } from "@/components/layout/Sidebar";
import { useAuth } from "@/lib/auth-context";

const navItems: SidebarNavItem[] = [
  { label: "Overview", to: "/admin" },
  { label: "Customers", to: "/admin/customers" },
  { label: "Finance", to: "/admin/finance" },
  { label: "Analytics", to: "/admin/analytics" },
];

export function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="flex min-h-screen bg-paper">
      <Sidebar
        title="Platform admin"
        subtitle="Internal"
        items={navItems}
        footer={
          <div className="flex flex-col gap-2">
            <span className="truncate text-xs text-ink-soft" title={user?.email}>
              {user?.email}
            </span>
            <button
              type="button"
              onClick={handleLogout}
              className="text-left text-xs font-medium text-ink-soft hover:text-ink"
            >
              Log out
            </button>
            <Link to="/" className="text-xs text-ink-soft hover:text-ink">
              ← Back to site
            </Link>
          </div>
        }
      />
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-5xl px-8 py-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
